var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"above-header"},[_c('span',{staticClass:"above-header__new"},[_vm._v("NEW")]),_c('a',{attrs:{"target":"_blank","href":this.link}},[_vm._v(_vm._s(this.content))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b497e56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Sites/AT/assets/js/vue/components/header/AboveHeader.vue
// module id = 124
// module chunks = 0 1